import RecipeModel from './RecipeModel';
import ProductModel from './ProductModel';

const NewRecipeDto = {
    recipeDto: RecipeModel,
    ProductAndQuantityDto: {
        product: ProductModel,
        amountGross: 0,
        amountNet: 0,
        amountGrossCradle: 0,
        amountNetCradle: 0,
    },
    listOfProducts: [],
    recipeOutput: [],
};

export default NewRecipeDto;
